import { defaultLang } from './config-lang';

export const getLanguage = (): string => {
  try {
    const lang = document.getElementsByTagName('html')[0].getAttribute('lang');
    if (lang === 'en-us') return 'en';
    return lang != null ? lang : defaultLang.value;
  } catch {
    return defaultLang.value;
  }
};
